import React from "react";
import "./style.css";

import { Oval } from  "react-loader-spinner";

const Loading = ({ text }) => {
    return (
        <div className="loading-container">
            <Oval
                height={60}
                width={60}
                color="#1e90ff"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#1e90ff"
                strokeWidth={3}
                strokeWidthSecondary={3}
            />

            { text ? <span className="loading-text">{text}</span> : null}
        </div>
    )
};

export default Loading;
